(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-wholesale-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let currentCollection = null;
    let currentCollectionName = 'New Release';
    let currentOccasion = 'all';
    let currentSort = 'default';
    let allProducts = [];
    
    // Toggle dropdowns
    document.querySelectorAll('.dropdown').forEach(dropdown => {
      const btn = dropdown.querySelector('.dropdown-btn');
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        document.querySelectorAll('.dropdown').forEach(d => {
          if (d !== dropdown) d.classList.remove('active');
        });
        dropdown.classList.toggle('active');
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function() {
      document.querySelectorAll('.dropdown').forEach(d => d.classList.remove('active'));
    });

    // Category filter
    document.querySelectorAll('#categoryContent a').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const filter = this.dataset.filter;
        const handle = this.dataset.handle;
        const collectionName = this.textContent;
        
        document.getElementById('categoryLabel').textContent = collectionName;
        document.getElementById('categoryDropdown').classList.remove('active');
        
        if (filter === 'all') {
          currentCollection = 'all';
          currentCollectionName = 'All Categories';
        } else {
          currentCollection = handle;
          currentCollectionName = collectionName;
        }
        
        document.getElementById('sectionTitle').textContent = currentCollectionName;
        loadProducts();
      });
    });

    // Occasion filter
    document.querySelectorAll('#occasionContent a').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        currentOccasion = this.dataset.occasion;
        
        document.getElementById('occasionLabel').textContent = this.textContent;
        document.getElementById('occasionDropdown').classList.remove('active');
        
        filterProducts();
      });
    });

    // Sort filter
    document.querySelectorAll('#sortContent a').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        currentSort = this.dataset.sort;
        
        document.getElementById('sortLabel').textContent = this.textContent;
        document.getElementById('sortDropdown').classList.remove('active');
        
        sortAndDisplayProducts();
      });
    });

    // Load products from collection
    function loadProducts() {
      if (!currentCollection) {
        document.getElementById('productsGrid').innerHTML = '';
        document.getElementById('mobileSwiper').innerHTML = '';
        return;
      }
      
      const url = currentCollection === 'all' 
        ? '/collections/all/products.json?limit=250'
        : `/collections/${currentCollection}/products.json?limit=250`;
      
      fetch(url)
        .then(response => response.json())
        .then(data => {
          console.log('Products loaded:', data.products.length, 'products');
          allProducts = data.products;
          
          const allTags = new Set();
          data.products.forEach(p => {
            p.tags.forEach(tag => allTags.add(tag));
          });
          console.log('All unique tags:', Array.from(allTags));
          
          filterProducts();
        })
        .catch(error => {
          console.error('Error loading products:', error);
          document.getElementById('productsGrid').innerHTML = '<div class="no-products">Error loading products</div>';
        });
    }

    // Filter products by occasion
    function filterProducts() {
      if (!currentCollection) {
        return;
      }
      
      let filtered = allProducts;
      
      if (currentOccasion !== 'all') {
        console.log('Filtering by occasion:', currentOccasion);
        
        filtered = allProducts.filter(product => {
          const hasTag = product.tags && product.tags.some(tag => {
            const normalizedTag = tag.trim().toLowerCase();
            const normalizedOccasion = currentOccasion.trim().toLowerCase();
            return normalizedTag === normalizedOccasion;
          });
          
          if (hasTag) {
            console.log('Product matched:', product.title, 'Tags:', product.tags);
          }
          
          return hasTag;
        });
        
        console.log('Filtered products count:', filtered.length);
      }
      
      sortAndDisplayProducts(filtered);
    }

    // Sort and display products
    function sortAndDisplayProducts(products = allProducts) {
      if (!currentCollection) {
        return;
      }
      
      let sorted = [...products];
      
      switch(currentSort) {
        case 'title-asc':
          sorted.sort((a, b) => a.title.localeCompare(b.title));
          break;
        case 'title-desc':
          sorted.sort((a, b) => b.title.localeCompare(a.title));
          break;
        case 'price-asc':
          sorted.sort((a, b) => parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price));
          break;
        case 'price-desc':
          sorted.sort((a, b) => parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price));
          break;
        case 'date-desc':
          sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          break;
      }
      
      displayProducts(sorted);
    }

    // Generate product card HTML
    function generateProductCard(product) {
      let imageUrl = '';
      if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].src || product.images[0];
      } else if (product.image) {
        imageUrl = product.image.src || product.image;
      } else if (product.featured_image) {
        imageUrl = product.featured_image;
      }
      
      const price = parseFloat(product.variants[0].price);
      const comparePrice = parseFloat(product.variants[0].compare_at_price);
      const hasDiscount = comparePrice && comparePrice > price;
      const discount = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
      const isNew = product.tags.includes('new') || product.tags.includes('New');
      
      return `
        <div class="product-card">
          <div class="product-image">
            ${hasDiscount ? `<span class="badge badge-sale">-${discount}%</span>` : ''}
            ${isNew && !hasDiscount ? '<span class="badge badge-new">New</span>' : ''}
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" onerror="this.src='https://via.placeholder.com/400x400?text=No+Image'">` : '<div style="width:100%;height:100%;background:#f0f0f0;display:flex;align-items:center;justify-content:center;">No Image</div>'}
          </div>
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <button class="product-button" onclick="window.location.href='/account/login'">
              Log in to See Price
            </button>
          </div>
        </div>
      `;
    }

    // Display products
    function displayProducts(products) {
      const grid = document.getElementById('productsGrid');
      const mobileSwiper = document.getElementById('mobileSwiper');
      
      if (products.length === 0) {
        grid.innerHTML = '<div class="no-products">No products found matching the selected filters</div>';
        mobileSwiper.innerHTML = '<swiper-slide><div class="no-products">No products found</div></swiper-slide>';
        return;
      }
      
      // Desktop Grid
      grid.innerHTML = products.map(product => generateProductCard(product)).join('');
      
      // Mobile Slider
      mobileSwiper.innerHTML = products.map(product => {
        return `<swiper-slide>${generateProductCard(product)}</swiper-slide>`;
      }).join('');
      
      // Initialize Swiper after content is loaded
      setTimeout(() => {
        const swiperParams = {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          speed: 800,
          pagination: {
            clickable: true,
            dynamicBullets: false,
          },
        };
        
        Object.assign(mobileSwiper, swiperParams);
        mobileSwiper.initialize();
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reatil-product-listing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let currentCollection = null;
    let currentCollectionName = 'New Release';
    let currentOccasion = 'all';
    let currentSort = 'default';
    let allProducts = [];
    
    // Initialize - Load default collection on page load
    if ('{{ section.settings.default_collection }}' !== '') {
      currentCollection = '{{ section.settings.default_collection }}';
      loadProducts();
    }
    
    // Toggle dropdowns
    document.querySelectorAll('.dropdown').forEach(dropdown => {
      const btn = dropdown.querySelector('.dropdown-btn');
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        document.querySelectorAll('.dropdown').forEach(d => {
          if (d !== dropdown) d.classList.remove('active');
        });
        dropdown.classList.toggle('active');
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function() {
      document.querySelectorAll('.dropdown').forEach(d => d.classList.remove('active'));
    });

    // Category filter
    document.querySelectorAll('#categoryContent a').forEach(link => {
      link.addEventListener('click', function(e) {
       
        const filter = this.dataset.filter;
        const handle = this.dataset.handle;
        const collectionName = this.textContent;
        
        document.getElementById('categoryLabel').textContent = collectionName;
        document.getElementById('categoryDropdown').classList.remove('active');
        
        if (filter === 'all') {
          currentCollection = 'all';
          currentCollectionName = 'All Categories';
        } else {
          currentCollection = handle;
          currentCollectionName = collectionName;
        }
        
        document.getElementById('sectionTitle').textContent = currentCollectionName;
        loadProducts();
      });
    });

    // Occasion filter
    document.querySelectorAll('#occasionContent a').forEach(link => {
      link.addEventListener('click', function(e) {
       
        currentOccasion = this.dataset.occasion;
        
        document.getElementById('occasionLabel').textContent = this.textContent;
        document.getElementById('occasionDropdown').classList.remove('active');
        
        filterProducts();
      });
    });

    // Sort filter
    document.querySelectorAll('#sortContent a').forEach(link => {
      link.addEventListener('click', function(e) {
       
        currentSort = this.dataset.sort;
        
        document.getElementById('sortLabel').textContent = this.textContent;
        document.getElementById('sortDropdown').classList.remove('active');
        
        sortAndDisplayProducts();
      });
    });

    // Load products from collection
    function loadProducts() {
      if (!currentCollection) {
        document.getElementById('productsGrid').innerHTML = '';
        document.getElementById('mobileSwiper').innerHTML = '';
        return;
      }
      
      const url = currentCollection === 'all' 
        ? '/collections/all/products.json?limit=250'
        : `/collections/${currentCollection}/products.json?limit=250`;
      
      fetch(url)
        .then(response => response.json())
        .then(data => {
          console.log('Products loaded:', data.products.length, 'products');
          allProducts = data.products;
          
          const allTags = new Set();
          data.products.forEach(p => {
            p.tags.forEach(tag => allTags.add(tag));
          });
          console.log('All unique tags:', Array.from(allTags));
          
          filterProducts();
        })
        .catch(error => {
          console.error('Error loading products:', error);
          document.getElementById('productsGrid').innerHTML = '<div class="no-products">Error loading products</div>';
        });
    }

    // Filter products by occasion
    function filterProducts() {
      if (!currentCollection) {
        return;
      }
      
      let filtered = allProducts;
      
      if (currentOccasion !== 'all') {
        console.log('Filtering by occasion:', currentOccasion);
        
        filtered = allProducts.filter(product => {
          const hasTag = product.tags && product.tags.some(tag => {
            const normalizedTag = tag.trim().toLowerCase();
            const normalizedOccasion = currentOccasion.trim().toLowerCase();
            return normalizedTag === normalizedOccasion;
          });
          
          if (hasTag) {
            console.log('Product matched:', product.title, 'Tags:', product.tags);
          }
          
          return hasTag;
        });
        
        console.log('Filtered products count:', filtered.length);
      }
      
      sortAndDisplayProducts(filtered);
    }

    // Sort and display products
    function sortAndDisplayProducts(products = allProducts) {
      if (!currentCollection) {
        return;
      }
      
      let sorted = [...products];
      
      switch(currentSort) {
        case 'title-asc':
          sorted.sort((a, b) => a.title.localeCompare(b.title));
          break;
        case 'title-desc':
          sorted.sort((a, b) => b.title.localeCompare(a.title));
          break;
        case 'price-asc':
          sorted.sort((a, b) => parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price));
          break;
        case 'price-desc':
          sorted.sort((a, b) => parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price));
          break;
        case 'date-desc':
          sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          break;
      }
      
      displayProducts(sorted);
    }

    // Generate product card HTML
    function generateProductCard(product) {
      let imageUrl = '';
      if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].src || product.images[0];
      } else if (product.image) {
        imageUrl = product.image.src || product.image;
      } else if (product.featured_image) {
        imageUrl = product.featured_image;
      }
      
      const price = parseFloat(product.variants[0].price);
      const comparePrice = parseFloat(product.variants[0].compare_at_price);
      const hasDiscount = comparePrice && comparePrice > price;
      const discount = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
      const isNew = product.tags.includes('new') || product.tags.includes('New');
      
      // Format prices for display
      const formattedPrice = '$' + price.toFixed(2);
      const formattedComparePrice = comparePrice ? '$' + comparePrice.toFixed(2) : '';
      
      return `
        <div class="product-card" onclick="window.location.href='/products/${product.handle}'">
          <div class="product-image">
            ${hasDiscount ? `<span class="badge badge-sale">-${discount}%</span>` : ''}
            ${isNew && !hasDiscount ? '<span class="badge badge-new">New</span>' : ''}
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" onerror="this.src='https://via.placeholder.com/400x400?text=No+Image'">` : '<div style="width:100%;height:100%;background:#f0f0f0;display:flex;align-items:center;justify-content:center;">No Image</div>'}
          </div>
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <div class="product-price-wrapper">
              <span class="product-price">${formattedPrice}</span>
              ${hasDiscount ? `<span class="product-compare-price">${formattedComparePrice}</span>` : ''}
            </div>
          </div>
        </div>
      `;
    }

    // Display products
    function displayProducts(products) {
      const grid = document.getElementById('productsGrid');
      const mobileSwiper = document.getElementById('mobileSwiper');
      
      if (products.length === 0) {
        grid.innerHTML = '<div class="no-products">No products found matching the selected filters</div>';
        mobileSwiper.innerHTML = '<swiper-slide><div class="no-products">No products found</div></swiper-slide>';
        return;
      }
      
      // Desktop Grid
      grid.innerHTML = products.map(product => generateProductCard(product)).join('');
      
      // Mobile Slider
      mobileSwiper.innerHTML = products.map(product => {
        return `<swiper-slide>${generateProductCard(product)}</swiper-slide>`;
      }).join('');
      
      // Initialize Swiper after content is loaded
      setTimeout(() => {
        const swiperParams = {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          speed: 800,
          pagination: {
            clickable: true,
            dynamicBullets: false,
          },
        };
        
        Object.assign(mobileSwiper, swiperParams);
        mobileSwiper.initialize();
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
